import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

interface GetQueryProps {
  entityName: string;
  columnNames: string[];
}

export const getQuery = ({ entityName, columnNames }: GetQueryProps): DocumentNode => {
  const query = `
    query { cmdi  { ${entityName} { ${columnNames.join(', ')} } } }
    `;
  return gql`
    ${query}
  `;
};

export const getMutation = ({ entityName, columnNames }: GetQueryProps): DocumentNode => {
  const mutationBuilder = `
    mutation ($object: ${entityName}_insert_input!) {
      cmdi {
        insert_${entityName}_one(
          object: $object,
          on_conflict: {constraint: ${entityName}_pkey, update_columns: [${columnNames.join(', ')}]}
        ) {
          ${columnNames.join('\n')}
        }
      }
    }
    `;
  return gql`
    ${mutationBuilder}
  `;
};

export const getDeleteMutation = ({ entityName, columnNames }: GetQueryProps): DocumentNode => {
  const mutationBuilder = `
    mutation ($id: uuid!) {
      cmdi {
        delete_${entityName}_by_pk(id: $id) {
          ${columnNames.join('\n')}
        }
      }
    }
    `;
  return gql`
    ${mutationBuilder}
  `;
};
